import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=1cf20885&"
import script from "./SearchForm.vue?vue&type=script&lang=ts&"
export * from "./SearchForm.vue?vue&type=script&lang=ts&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports